export default __webpack_public_path__ + "static/Vacuum_Compartment_Moonpool-da73a46b35576790cced5e03121cfa19.png";